import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTelevisionOld: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconTelevisionOld"><Path d="M14.9152 6L17.904 3.67538L16.6761 2.09668L12.0008 5.733L7.32554 2.09668L6.09766 3.67538L9.08645 6H2V21H22V6H14.9152Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTelevisionOld;
